import React, { ReactNode } from 'react'
import { Box } from '@mui/material'

// Wide for wide tables and cards, narrow for forms. Beyond these widths extra space only pushes columns apart.
const PAGE_WIDTH = { wide: 1440, narrow: 720 } as const

// The space above every page on desktop, matching the side gutters and the margin below a sheet
export const PAGE_TOP_GAP = 24

// The page's side gutters, shared by both page layouts
export const PAGE_GUTTER_X = { xs: 2, sm: 3 } as const

interface PageContainerProps {
    width: keyof typeof PAGE_WIDTH
    children: ReactNode
}

/**
 * A page laid straight on the canvas, for pages built from blocks that bring their own surfaces: forms,
 * cards, wide tables. A page that is one list sits on a sheet instead (SheetPage).
 */
export const PageContainer: React.FC<PageContainerProps> = ({ width, children }) => (
    <Box
        sx={{
            width: '100%',
            maxWidth: PAGE_WIDTH[width],
            mx: 'auto',
            px: PAGE_GUTTER_X,
            // On phones the layout leaves no gap under the toolbar, so the page keeps a little air of its own
            pt: { xs: 2, sm: 0 },
            pb: 4,
        }}
    >
        {children}
    </Box>
)
